import React from 'react'

import { ListScreen } from './screens/ListScreen'
import { StartScreen } from './screens/StartScreen'
import { useNavigationStore } from './state/navigationStore'

const ScreenRouter = () => {
  const screen = useNavigationStore((state) => state.screen)

  switch (screen) {
    case 'start':
      return <StartScreen />
    case 'list':
      return <ListScreen />
    default:
      return <></>
  }
}

export { ScreenRouter }
